<template>
	<div class="container">
		<indexPcs v-if="!isTrue"></indexPcs>
		<indexH5s v-if="isTrue"></indexH5s>
	</div>
</template>

<script>
import indexPcs from '@/component/products/fsh-rapid-test_pc.vue'  //pc组件
import indexH5s from '@/component/products/fsh-rapid-test_h5.vue'  //h5组件
export default {
	name: 'products-infos',
	components:{
		indexPcs,
		indexH5s,
	},
	data() {
		return {
			isTrue: null,
		}
	},
	created(){
		let that = this;
		let isTrue = null;
		let isiPad = (navigator.userAgent.match(/(iPad)/) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1));
		if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|OpenHarmony|HarmonyOS|HarmonyOSNext|OpenHarmony/i.test(navigator.userAgent) || isiPad) {
			if(window.innerWidth > 2000) {
				that.isTrue = false;
			}else {
				that.isTrue = true;
			}
		}else {
			that.isTrue = false;
		}
	},
	mounted() {
		let that = this;
	},
	watch: {
		//
	},
	methods: {
		//
	}
}
</script>

<style lang="less" scoped>
</style>
